import { Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS } from "../lib/business";

/** Visible business identity block for PhonePe / PG reviewers & customers */
export default function BusinessContact({ className = "" }) {
  return (
    <div
      className={`rounded-2xl border border-white/10 bg-ink-50/50 p-6 md:p-8 ${className}`}
      data-testid="business-contact"
    >
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-3">
        Business details
      </div>
      <h2 className="font-display text-2xl md:text-3xl tracking-tight mb-1">
        {BUSINESS.legalName}
      </h2>
      <p className="text-sm text-zinc-500 mb-6">
        Legal / trading name · Product engineering studio
      </p>
      <ul className="space-y-4 text-sm text-zinc-300">
        <li className="flex gap-3">
          <MapPin size={16} className="mt-0.5 shrink-0 text-zinc-500" />
          <span>
            {BUSINESS.addressLines.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </span>
        </li>
        <li className="flex gap-3 items-center">
          <Phone size={16} className="shrink-0 text-zinc-500" />
          <a href={BUSINESS.phoneHref} className="hover:text-white transition-colors">
            {BUSINESS.phoneDisplay}
          </a>
        </li>
        <li className="flex gap-3 items-center">
          <Mail size={16} className="shrink-0 text-zinc-500" />
          <a
            href={`mailto:${BUSINESS.email}`}
            className="hover:text-white transition-colors break-all"
          >
            {BUSINESS.email}
          </a>
        </li>
      </ul>
    </div>
  );
}
